import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { EnvironmentService } from '@app/core/environment-service';

/**
 * Matches /faq to the surface's own static FAQ page (mirror builds like fastcs2).
 * When the surface flag is off, the route falls through to the shared CMS-driven FAQ module.
 */
export const staticFaqPageCanMatchGuard: CanMatchFn = () => {
  return inject(EnvironmentService).staticFaqPageIsEnabled();
};
